import React from 'react';

/*
import {
  hf,
  hfDTM,
  ht,
  cr,
  a,
  f,
  ls,
  gs,
  useMsgz,
  useLdrz,
  BoxC,
  BtnC,
  CbxC,
  GridC,
  SrlC,
  TblC,
  TextC,
  _cv_60___Mz,
  _cv_61___Mz,
} from 'lib';
*/
import * as BoxC from "./_ccbBoxC";
import * as SrlC from "./_ccbSrlC";
import * as TextC from "./_ccbTextC";
import * as GridC from "./_cccGridC";
import * as CbxC from "./_cccCbxC";
import * as BtnC from "./_cccBtnC";
import * as cr from './_cr';
import { a } from "./_csAbt";
import * as gs from "./_csGbl";
import * as ls from "./_csLcl"; // local state
import { useLdrz } from "./_csLdr";
import { useMsgz } from "./_csMdlMsg";
import * as _cv_60___Mz from "./_cv_60___Mz";
import * as _cv_61___Mz from "./_cv_61___Mz";
import * as ht from './_ht';
import * as hf from './_hf';
import * as hfDTM from './_hfDTM';

import * as ihd from './ihd';
import * as icm from './icm';
import * as icv from './icv';

import * as icvI10___Mz from './icvI10___Mz';
import * as icvI1z___Mz from './icvI1z___Mz';
import * as icvI1y___Mz from './icvI1y___Mz';

const $cellCs11 = [] as ht.ls;
const $cellCs12 = [] as ht.ls;
const $cellCs13 = [] as ht.ls;
const $cellCs14 = [] as ht.ls; // for lotty

const $cellCs21 = [] as ht.ls;
const $cellCs22 = [] as ht.ls;
const $cellCs23 = [] as ht.ls;

const $lblW = 12;

const $cslz = {
  date: '',
  roomKey: -1,
  zoneKey: -1,
};

let $_601s = [] as ht.ls;
let $_611s = [] as ht.ls;

let $i10rs = [] as ht.ls;

let $i1z5z = {} as ht.dz; // 他の予約データ

let $chkAll = -1;
let $ltyDoneDates = [] as ht.ls; // for lotty

const $tgtz1 = {
  crt: '',
  stt: '',
  end: '',
  dates: [] as ht.ls,
};

const $tgtz2 = {
  crt: '',
  stt: '',
  end: '',
  dates: [] as ht.ls,
};

let $crtPrsDtm = new Date();
let $oldPrsDtm = new Date();

const $setCellCsN1 = (pz: {
  ccd: ht.s
  _611s: ht.ls,
  dates: ht.ls,
  cellCsN1: ht.ls,
  onPrs?: (_dz: ht.dz) => void,
}) => {
  pz.cellCsN1.splice(0);
  pz.cellCsN1.push(
    {
      boxStlz: a(`dw/${$lblW} f/n sc/${pz.ccd}`),
      oClds: [
        cr.c(TextC.N, {
          key: -10,
          textz: {
            pfx: '月',
            stlz: a('ts/s'),
          }
        })
      ]
    }
  );
  pz.dates.map((_date: ht.s) => {
    pz.cellCsN1.push(
      {
        boxStlz:
          hf.i(_date, pz._611s) ?
            a(`sc/lt4`)
            : a(`sc/${pz.ccd}`),
        oClds: [
          cr.c(BoxC.N, {
            key: -10,
            boxStlz: a(`dw/f dh/f fd/ccc`),
            pslPtyz: {
              onPress:
                pz.onPrs && !hf.i(_date, $ltyDoneDates) && !hf.i(_date, $_611s) ?
                  () => {
                    if (pz.onPrs) pz.onPrs({ date: _date });
                  }
                  : undefined,
            },
            oClds: [
              cr.c(TextC.N, {
                key: _date,
                textz: {
                  pfx: hfDTM.cvtMth(_date),
                  stlz: a('ts/s'),
                }
              })
            ]
          })
        ]
      }
    )
  });
};

const $setCellCsN3 = (pz: {
  ccd: ht.s
  _601s: ht.ls,
  _611s: ht.ls,
  dates: ht.ls,
  cellCsN3: ht.ls,
  onPrs?: (_dz: ht.dz) => void,
}) => {
  pz.cellCsN3.splice(0);
  pz.cellCsN3.push(
    {
      boxStlz: a(`dw/${$lblW} f/n sc/${pz.ccd}`),
      oClds: [
        cr.c(TextC.N, {
          key: -10,
          textz: {
            pfx: '曜日',
            stlz: a('ts/s'),
          }
        })
      ]
    }
  );
  pz.dates.map((_date: ht.s) => {
    pz.cellCsN3.push(
      {
        boxStlz:
          hf.i(_date, pz._611s) ?
            a(`sc/lt4`)
          : hfDTM.cvtDow(_date) == '日' || hf.i(_date, pz._601s) ?
            a(`sc/rd4`)
          : hfDTM.cvtDow(_date) == '土' ?
            a(`sc/rd1`)
          : a(`sc/${pz.ccd}`),
        oClds: [
          cr.c(BoxC.N, {
            key: -10,
            boxStlz: a(`dw/f dh/f fd/ccc`),
            pslPtyz: {
              onPress:
                pz.onPrs && !hf.i(_date, $ltyDoneDates) && !hf.i(_date, $_611s) ?
                  () => {
                    if (pz.onPrs) pz.onPrs({ date: _date });
                  }
                  : undefined,
            },
            oClds: [
              cr.c(TextC.N, {
                key: _date,
                textz: {
                  pfx:
                    hf.i(_date, pz._611s) ?
                      '休'
                      : hfDTM.cvtDow(_date),
                  stlz: a('ts/s'),
                }
              })
            ]
          })

        ]
      }
    )
  });
};

const $setCellCsN4 = (pz: {
  ccd: ht.s
  _601s: ht.ls,
  _611s: ht.ls,
  dates: ht.ls,
  cellCsN4: ht.ls,
  onPrs?: (_dz: ht.dz) => void,
  ltyTgtDatez: ht.dz,
}) => {
  pz.cellCsN4.splice(0);
/* 20231205 削除 オフライン抽選
  pz.cellCsN4.push(
    {
      boxStlz: a(`dw/${$lblW} f/n sc/${pz.ccd}`),
      oClds: [
        cr.c(TextC.N, {
          key: -10,
          textz: {
            pfx: '抽選',
            stlz: a('ts/s'),
          }
        })
      ]
    }
  );
  pz.dates.map((_date: ht.s) => {
    pz.cellCsN4.push(
      {
        boxStlz:
          a(`sc/${pz.ccd}`),
        oClds: [
          hf.i(_date, $_611s) ?
            cr.c(TextC.N, {
              key: _date,
              boxStlz: a(`dh/f dw/f fd/ccc sc/lt4`),
              textz: {
                pfx: '外',
                stlz: a('tc/lt9 ts/s'),
              }
            })
            : hf.i(_date, $ltyDoneDates) ?
              cr.c(TextC.N, {
                key: _date,
                boxStlz: a(`dh/f dw/f fd/ccc sc/${pz.ccd}`),
                textz: {
                  pfx: '済',
                  stlz: a('tc/lt9 ts/s'),
                }
              })
              :
              cr.c(CbxC.SS, {
                key: _date,
                boxStlz: a(`dh/f dw/f sc/${pz.ccd}`),
                cz: {
                  vle: pz.ltyTgtDatez[_date],
                  onChg: (_n: ht.n) => {
                    pz.ltyTgtDatez[_date] = _n;
                  }
                },
                cbxCz: {
                  boxStlz: {
                    sctz: a(`dh/f dw/f fd/ccc sc/${pz.ccd}`),
                    nmlz: a(`dh/f dw/f fd/ccc sc/${pz.ccd}`),
                  },
                  iconPtyz: {
                    sctz: a(`icc/lt9 ics/2`),
                    nmlz: a(`icc/lt9 ics/2`),
                  }
                },
              })
        ]
      }
    )
  });
*/
};

const $setCellCsN2 = (pz: {
  ccd: ht.s,
  _611s: ht.ls,
  dates: ht.ls,
  cellCsN2: ht.ls,
  onPrs?: (_dz: ht.dz) => void,
}) => {
  pz.cellCsN2.splice(0);
  pz.cellCsN2.push(
    {
      boxStlz: a(`dw/${$lblW} f/n sc/${pz.ccd}`),
      oClds: [
        cr.c(TextC.N, {
          key: -10,
          textz: {
            pfx: '日',
            stlz: a('ts/s'),
          }
        })
      ]
    }
  );
  pz.dates.map((_date: ht.s) => (
    pz.cellCsN2.push(
      {
        boxStlz:
          hf.i(_date, pz._611s) ?
            a(`sc/lt4`)
          : _date == $cslz.date ?
            a(`sc/yw2`)
          : a(`sc/${pz.ccd}`),
        oClds: [
          cr.c(BoxC.N, {
            key: -10,
            boxStlz: a(`dw/f dh/f fd/ccc`),
            pslPtyz: {
              onPress:
                pz.onPrs && !hf.i(_date, $ltyDoneDates) && !hf.i(_date, $_611s) ?
                  () => {
                    if (pz.onPrs) pz.onPrs({ date: _date });
                  }
                  : undefined,
            },
            oClds: [
              cr.c(TextC.N, {
                key: _date,
                textz: {
                  pfx: hfDTM.cvtDay(_date),
                  stlz: a('ts/s'),
                }
              })
            ]
          })

        ]
      }
    )
  ));
};

const $setHdr = (pz: {
  hdrs: ht.ls,
  cellCsN1: ht.ls,
  cellCsN2: ht.ls,
  cellCsN3: ht.ls
  cellCsN4?: ht.ls // for lotty
}) => {
  if (pz.cellCsN4) pz.hdrs.push({ cellCs: pz.cellCsN4 });
  pz.hdrs.push({ cellCs: pz.cellCsN1 });
  pz.hdrs.push({ cellCs: pz.cellCsN2 });
  pz.hdrs.push({ cellCs: pz.cellCsN3 });
};

const $setBdys = (pz: {
  hdrs: ht.ls,
  bdys: ht.ls,
  sPz: ht.dz,
  tgtz: ht.dz,
  bEdit: ht.b,
  udtThis: () => void,
  i1zz?: ht.dz,
  sMsgz: ht.dz,
  bMplDay?: ht.b, // multiple day
  onPrs?: (_dz: ht.dz) => void,
}) => {

  const _bkdz = icm.grtBkd({
    i1zs: [pz.i1zz],
    bMplDay: pz.bMplDay,
  });

  $i10rs.map((_roomz: ht.dz, idx: ht.n) => {

    //hf.l(`icvI1z___TzAby 370: ${hf.s(_roomz)}`);

    if (idx != 0 && idx % 3 == 0) {
      pz.hdrs.map((hdrz: ht.dz) => {
        pz.bdys.push(hdrz);
      });
    }

    pz.bdys.push({
      cellCs: [
        {
          boxStlz: a(`sc/${pz.sPz.crt.dffz.clr}9`),
          oClds: [
            cr.c(TextC.N, { // 施設名
              key: -10,
              textz: {
                pfx: _roomz.pfx,
                stlz: a('tb tc/lt1 ts/s'),
              }
            })
          ]
        }
      ]
    });

    const _zones = hf.get1(_roomz.cldz.i11rs, {})?.cldz?.i111s;
    _zones.map((_zonez: ht.dz) => {

      const _cellCs4a = [] as ht.ls;

      _cellCs4a.push(
        {
          boxStlz:
            _roomz._key == $cslz.roomKey && _zonez._key == $cslz.zoneKey ?
              a(`dh/f dw/${$lblW} f/n sc/yw2`)
              : a(`dh/f dw/${$lblW} f/n sc/lt1`),
          oClds: [
            cr.c(TextC.N, { // 時間帯名
              key: -10,
              textz: {
                pfx: _zonez._pfx,
                //                stlz: a('th/2 ts/s'),
                stlz: a('ts/s'),
              }
            })
          ]
        }
      );

      pz.tgtz.dates.map((_date: ht.s) => {
        _cellCs4a.push(
          {
            boxStlz:
              hf.i(_date, $_611s) ? // 休館日の場合
                a('dh/f dw/f sc/lt4')
              : _bkdz[_roomz._fst] &&
                _bkdz[_roomz._fst][_zonez._fst] &&
                _bkdz[_roomz._fst][_zonez._fst][_date]?.bBkd ? // 選択した場合 予約よりも優先してハイライト表示
                a('dh/f dw/f sc/bl8')
              : 
              (
                $i1z5z[_roomz._fst] &&
                $i1z5z[_roomz._fst][_zonez._fst] &&
                $i1z5z[_roomz._fst][_zonez._fst][_date] &&
                $i1z5z[_roomz._fst][_zonez._fst][_date].i1z5a1100i >= 1
              ) ? // 予約が入っている場合
//                a(`dh/f dw/f f/1 fd/rcc sc/lt3`)
                a(`dh/f dw/f f/1 fd/rcc sc/lt4`)
/*
              : _bkdz[_roomz._fst] &&
                _bkdz[_roomz._fst][_zonez._fst] &&
                _bkdz[_roomz._fst][_zonez._fst][_date]?.bBkd ? // 選択した場合
                a('dh/f dw/f sc/bl8')
*/
              : _roomz._key == $cslz.roomKey && _zonez._key == $cslz.zoneKey && _date == $cslz.date ? // カーソルがのっている場合
                a(`dh/f dw/f sc/yw2`)
              : a('dh/f dw/f sc/lt1'),
            oClds: [
              cr.c(BoxC.N, {
                key: -10,
                pslPtyz:
                  pz.onPrs && !hf.i(_date, $ltyDoneDates) && !hf.i(_date, $_611s) ? // 抽選済・休業日以外で、pz.onPrs が定義されている場合
                  {
                    onPress: () => {
                      if (pz.onPrs) pz.onPrs({ date: _date });
                    }
                  }
                  : hf.i(_date, $_611s) || pz.bEdit == false ? // 休業日か閲覧モードの場合
                    null
                  :
                  (
                    pz.sPz.crt.ctt == 'r' &&
                    $i1z5z[_roomz._fst] &&
                    $i1z5z[_roomz._fst][_zonez._fst] &&
                    $i1z5z[_roomz._fst][_zonez._fst][_date] &&
                    $i1z5z[_roomz._fst][_zonez._fst][_date].i1z5a1100i >= 1
                  ) ? // 予約が入っている場合（エントリーは入っていてもOK）
                    null
                  : 
                  {
                    onHoverIn: () => {
                      hf.udtDz($cslz, {
                        roomKey: _roomz._key,
                        zoneKey: _zonez._key,
                        date: _date
                      });
                      pz.udtThis();
                    },
                    onPress: async () => {
//hf.l(`icvI1z___TzAby 958a: ${$chkAll}`);
//hf.l(`icvI1z___TzAby 958b: ${hf.s(pz.tgtz.dates)}`);

                      $crtPrsDtm = new Date();
                      const _drc = $crtPrsDtm.getTime() - $oldPrsDtm.getTime();
                      $oldPrsDtm = $crtPrsDtm;
//                          if (_drc < 1000) {
                      if (_drc < 500) {
                        //hf.l(`icvI1z___TzAby 461: ${_drc}`);
                        pz.sMsgz.show({
                          textCz: {
                            textz: {
                              pfx: 'ゆっくりと選択してください',
                            }
                          }
                        })
                        return;
                      }
/*
                      if (pz.i1zz) {
                        const _roomFst = _roomz._fst;
                        const _zoneFst = _zonez._fst;
                        if (!hf.f(pz.i1zz.i1zrz.i1zrd3100s) || pz.i1zz.i1zrz.i1zrd3100s == _date || pz.bMplDay) {
                          pz.i1zz.i1zrz.i1zrd3100s =
                            pz.bMplDay ?
                              ''
                              : _date; // difference
                          // 選択済の部屋・利用日・時間帯かを確認
                          let _crtIdx = -1;
                          ihd.nd(pz.i1zz.i1z1s).map((_i1z1z: ht.dz, _idx: ht.n) => {
                            if (
                              _crtIdx == -1 &&
                              _roomFst == _i1z1z.i1z1i10r1f &&
                              _zoneFst == _i1z1z.i1z1i1111f &&
                              _date == _i1z1z.i1z1d1100s // difference
                            ) {
                              _crtIdx = _idx;
                            }
                          });
                          // 選択済の部屋・利用日・時間帯でない場合： i1z1z の追加
                          if (_crtIdx == -1) {
                            const _etyI1z1Idx = icm.getI1z1EtyIdx({
                              i1zz: pz.i1zz,
                              cntMax:
                                pz.bMplDay ?
                                  9999
                                  : icv.nI1z1CntMax, // difference
                            });
                            if (_etyI1z1Idx >= 0) {
                              const _i1z1z = icm.grtI1z1z({
                                i1z1d1100s: _date,
                                i10r_fst: _roomFst,
                                i111_fst: _zoneFst,
                                i10rs: $i10rs,
                                i15ra6100i: 1,
                                _601s: $_601s,
                              });
                              pz.i1zz.i1z1s[_etyI1z1Idx] = _i1z1z;
                            }
                            pz.sPz.udtAll();
                          }
                          // 選択済の部屋・利用日・時間帯である場合： i1z1s の削除
                          else {
                            pz.i1zz.i1z1s[_crtIdx] = {}; // 空白に変更 行を保持するため {} が必要
                            if (icm.chkEtyI1z1({
                              i1z1s: pz.i1zz.i1z1s,
                              cntMax:
                                pz.bMplDay ?
                                  9999
                                  : icv.nI1z1CntMax, // difference
                            })) { // 全て空白となった場合
                              pz.i1zz.i1zrz.i1zrd3100s = '';
                            }
                            pz.sPz.udtAll();
                          }
                        }
                        else {
                          //hf.l(`icvI1z___TzAby 368: here`);
                          pz.sMsgz.show({
                            textCz: {
                              textz: {
                                pfx: '利用日が異なる場合は、予約を分けて登録ください',
                              }
                            }
                          })
                        }
                      }
*/
                      const _onPrs = (date: ht.s) => {
                        if (pz.i1zz) {
                          const _roomFst = _roomz._fst;
                          const _zoneFst = _zonez._fst;
                          if (!hf.f(pz.i1zz.i1zrz.i1zrd3100s) || pz.i1zz.i1zrz.i1zrd3100s == date || pz.bMplDay) {
                            pz.i1zz.i1zrz.i1zrd3100s =
                              pz.bMplDay ?
                                ''
                                : date; // difference
                            // 選択済の部屋・利用日・時間帯かを確認
                            let _crtIdx = -1;
                            ihd.nd(pz.i1zz.i1z1s).map((_i1z1z: ht.dz, _idx: ht.n) => {
                              if (
                                _crtIdx == -1 &&
                                _roomFst == _i1z1z.i1z1i10r1f &&
                                _zoneFst == _i1z1z.i1z1i1111f &&
                                date == _i1z1z.i1z1d1100s // difference
                              ) {
                                _crtIdx = _idx;
                              }
                            });
                            // 選択済の部屋・利用日・時間帯でない場合： i1z1z の追加
                            if (_crtIdx == -1) {
//hf.l(`icvI1z___TzAby 572: ${date}, ${_crtIdx}`);
                              const _etyI1z1Idx = icm.getI1z1EtyIdx({
                                i1zz: pz.i1zz,
                                cntMax:
                                  pz.bMplDay ?
                                    9999
                                    : icv.nI1z1CntMax, // difference
                              });
                              if (_etyI1z1Idx >= 0) {
                                const _i1z1z = icm.grtI1z1z({
                                  i1z1d1100s: date,
                                  i10r_fst: _roomFst,
                                  i111_fst: _zoneFst,
                                  i10rs: $i10rs,
                                  i15ra6100i: 1,
                                  _601s: $_601s,
                                });
                                pz.i1zz.i1z1s[_etyI1z1Idx] = _i1z1z;
                              }
//                              pz.sPz.udtAll(); // $chkAll == 1 はまとめて実行
                              icm.udtTime(pz.i1zz); // チェック処理に必要な開始・終了時刻を設定
                              if ($chkAll == -1) pz.sPz.udtAll(); // $chkAll == 1 はまとめて実行
                            }
                            // 選択済の部屋・利用日・時間帯である場合： i1z1s の削除
                            else {
//hf.l(`icvI1z___TzAby 595: ${date}, ${_crtIdx}`);
                              //pz.i1zz.i1z1s[_crtIdx] = {}; // 空白に変更 行を保持するため {} が必要
                              pz.i1zz.i1z1s.splice(_crtIdx, 1); // 該当データを削除
                              if (icm.chkEtyI1z1({
                                i1z1s: pz.i1zz.i1z1s,
                                cntMax:
                                  pz.bMplDay ?
                                    9999
                                    : icv.nI1z1CntMax, // difference
                              })) { // 全て空白となった場合
                                pz.i1zz.i1zrz.i1zrd3100s = '';
                              }
//                              pz.sPz.udtAll(); // $chkAll == 1 はまとめて実行
                              icm.udtTime(pz.i1zz); // チェック処理に必要な開始・終了時刻を設定
                              if ($chkAll == -1) pz.sPz.udtAll(); // $chkAll == 1 はまとめて実行
                            }
                          }
                          else {
                            //hf.l(`icvI1z___TzAby 368: here`);
                            pz.sMsgz.show({
                              textCz: {
                                textz: {
                                  pfx: '利用日が異なる場合は、予約を分けて登録ください',
                                }
                              }
                            })
                          }
                        }
                      }
                      if ($chkAll == 1) {
                        await hf.ectSrlAsync(
                          $tgtz1.dates.map((_date2: ht.s) => async () => {
//hf.l(`icvI1z___Tz 622: ${_date2}`)
                            await _onPrs(_date2);
//                            await hf.waitAsync(100);
                          })
                        )
//hf.l(`icvI1z___Tz 629: here`)
                        pz.sPz.udtAll();
                      }
                      else {
                        _onPrs(_date);
                      }
                    }
                  },
/*
                boxStlz:
                  (
                    pz.sPz.crt.ctt == 'r' &&
                    $i1z5z[_roomz._fst] &&
                    $i1z5z[_roomz._fst][_zonez._fst] &&
                    $i1z5z[_roomz._fst][_zonez._fst][_date] &&
                    $i1z5z[_roomz._fst][_zonez._fst][_date].i1z5a1100i >= 1
                  ) ||
                  (
                    pz.sPz.crt.ctt == 'e' &&
                    $i1z5z[_roomz._fst] &&
                    $i1z5z[_roomz._fst][_zonez._fst] &&
                    $i1z5z[_roomz._fst][_zonez._fst][_date] &&
                    $i1z5z[_roomz._fst][_zonez._fst][_date].i1z5a2100i >= 1
                  ) ?
                    a(`dh/f dw/f f/1 fd/rcc sc/lt3`)
                  : a(`dh/f dw/f fd/rcc`),
*/
                oClds: [
                  cr.c(TextC.N, {
                    key: -10,
                    textz: {
/*
                      pfx:
                        (
                          pz.sPz.crt.ctt == 'r' &&
                          $i1z5z[_roomz._fst] &&
                          $i1z5z[_roomz._fst][_zonez._fst] &&
                          $i1z5z[_roomz._fst][_zonez._fst][_date] &&
                          $i1z5z[_roomz._fst][_zonez._fst][_date].i1z5a1100i >= 1
                        ) ?
                          'x'
                          : (
                            pz.sPz.crt.ctt == 'e' &&
                            $i1z5z[_roomz._fst] &&
                            $i1z5z[_roomz._fst][_zonez._fst] &&
                            $i1z5z[_roomz._fst][_zonez._fst][_date] &&
                            $i1z5z[_roomz._fst][_zonez._fst][_date].i1z5a2100i >= 1
                          ) ?
                            $i1z5z[_roomz._fst][_zonez._fst][_date].i1z5a2100i
                            : '      ',
*/
                      pfx: (
                        pz.sPz.crt.ctt == 'e' &&
                        $i1z5z[_roomz._fst] &&
                        $i1z5z[_roomz._fst][_zonez._fst] &&
                        $i1z5z[_roomz._fst][_zonez._fst][_date] &&
                        $i1z5z[_roomz._fst][_zonez._fst][_date].i1z5a2100i >= 1
                      ) ? // エントリーの場合のみエントリー数を表示
                        $i1z5z[_roomz._fst][_zonez._fst][_date].i1z5a2100i
                      : '　',
                      stlz: a('ts/s'),
                    },
                  })
                ]
              })
            ]
          }
        )
      });
      pz.bdys.push({
        //        boxStlz: a(`dh/4`),
        cellCs: _cellCs4a
      });
    });
  });

};

export const V3 = (pz: {
  sPz: ht.dz,
  cz: {
    bEdit: ht.b,
    bNext?: ht.b,
    bMplDay?: ht.b, // different day
    i10r_fsts?: ht.ls,
    i1zr_fst?: ht.n,
    date?: ht.s,
    dates?: ht.ls,
    i1zz?: ht.dz,
    _31r_fst: ht.n,
    row: ht.n,
    pfx: ht.s,
    sttMth: ht.s,
    endMth: ht.s,
    role?: ht.s,
    onPrs?: (_dz: ht.dz) => void,
    ltyTgtDatez?: ht.dz, // for lotty
    bLdr?: ht.b,
    bChkAll: ht.b, // 「選択した時間帯をすべて選択/解除する」を使用
  },
  boxStlz: ht.boxStlz,
}) => {

  //hf.l(`icvI1z___TzAby 599: ${hf.s(pz.cz)}`);

  //hf.l(`icvI1z___TzAby 747: ${hf.s(pz.cz.i10r_fsts)}`);

  const _sMsgz = useMsgz();
  const _sLdrz = useLdrz();

  const _udtThis = ls.udtThis();

  React.useEffect(() => {

    //hf.l(`icvI1z___TzAby 608: ${hf.s(pz.cz?.i10r_fsts)}, ${hf.s($tgtz1.dates)}`);
    if (hf.f(pz.cz?.i10r_fsts) && hf.f($tgtz1.dates)) {

      if (pz.cz.bLdr) _sLdrz.show();

      //hf.l(`icvI1z___TzAby 613: here`);
      hf.ectSrlAsync([
        async () => {
          hf.udtDz($cslz, { // 再表示した際の残像を消去
            date: '',
            roomKey: -1,
            zoneKey: -1,
          });
          $i10rs = await icvI10___Mz.loadI10rLsAsync({
            _31r_fst: pz.cz._31r_fst,
            i10r_fsts: pz.cz.i10r_fsts,
            lwrType: 1,
          });
          $i1z5z = await icvI1z___Mz.loadI1z5RzAsync({
            _31r_fst: pz.cz._31r_fst,
            i10r_fsts: pz.cz?.i10r_fsts,
            dates: $tgtz1.dates.concat($tgtz2.dates),
          });
          //hf.l(`icvI1z___TzAby 802: ${hf.s($i1z5z["330"]["219"]["2024-07-06"])}`)
          $_601s = await _cv_60___Mz.load_601AsAsync({ // 祝日
            dates: ($tgtz1.dates).concat($tgtz2.dates),
          })
          $_611s = await _cv_61___Mz.load_611AsAsync({ // 休館日
            dates: ($tgtz1.dates).concat($tgtz2.dates),
            cdn: `_611_31r1f = ${pz.cz._31r_fst}`,
          })
          //hf.l(`icvI1z___TzAby 636: here`);
          return true;
        },
        async () => {
          $setCellCsN1({
            ccd: `${pz.sPz.crt.dffz.clr}4`,
            _611s: $_611s,
            dates: $tgtz1.dates,
            cellCsN1: $cellCs11,
            onPrs: pz.cz.onPrs,
          });
          $setCellCsN2({
            ccd: `${pz.sPz.crt.dffz.clr}4`,
            _611s: $_611s,
            dates: $tgtz1.dates,
            cellCsN2: $cellCs12,
            onPrs: pz.cz.onPrs,
          });
          $setCellCsN3({
            ccd: `${pz.sPz.crt.dffz.clr}2`,
            _601s: $_601s,
            _611s: $_611s,
            dates: $tgtz1.dates,
            cellCsN3: $cellCs13,
            onPrs: pz.cz.onPrs,
          });
          if (pz.cz.row == 2) {
            $setCellCsN1({
              ccd: `${pz.sPz.crt.dffz.clr}4`,
              _611s: $_611s,
              dates: $tgtz2.dates,
              cellCsN1: $cellCs21,
              onPrs: pz.cz.onPrs,
            });
            $setCellCsN2({
              ccd: `${pz.sPz.crt.dffz.clr}4`,
              _611s: $_611s,
              dates: $tgtz2.dates,
              cellCsN2: $cellCs22,
              onPrs: pz.cz.onPrs,
            });
            $setCellCsN3({
              ccd: `${pz.sPz.crt.dffz.clr}2`,
              _601s: $_601s,
              _611s: $_611s,
              dates: $tgtz2.dates,
              cellCsN3: $cellCs23,
              onPrs: pz.cz.onPrs,
            });
          }
          //hf.l(`icvI1z___TzAby 686: here`);
          return true;
        },
        async () => {
          _udtThis();
          if (pz.cz.bLdr) _sLdrz.hide();
          //hf.l(`icvI1z___TzAby 692: here`);
          return true;
        },
      ])
    }
  }, [
    pz.cz.i10r_fsts ? pz.cz.i10r_fsts[0] : undefined,
    $tgtz1.dates,
    pz.cz._31r_fst,
  ])

  const _chgDate = async (date?: ht.s, ltyTgtDatez?: ht.dz) => {
    //hf.l(`icvI1z___TzAby 706: here`);
    if (date && $tgtz1.crt != date) {

      if (ltyTgtDatez) { // 表示に反映するため _chgDate 前に実行
        hf.clrDz(ltyTgtDatez);
        $chkAll = -1;
        const _i1yrs = await icvI1y___Mz.loadI1yrLsAsync({
          i1yrd1100sStt: hfDTM.cvtFdm(date),
          i1yrd1100sEnd: hfDTM.cvtLdm(date),
          i1yrs1100i: 1
        }) // 抽選情報
        hf.clrDz($ltyDoneDates);
        _i1yrs.map((i1yrz: ht.dz) => {
          if (i1yrz.i1yrs1100i == 1) {
            $ltyDoneDates.push(i1yrz.i1yrd1100s);
          }
        });
      }

      //hf.l(`icvI1z___TzAby 725: here`);
      hf.udtDz($tgtz1, {
        crt: date,
        dates: hfDTM.cvtMthDates(date, 1, pz.cz.row == 2 ? 15 : undefined),
      });
      hf.udtDz($tgtz2, {
        crt: date,
        dates: hfDTM.cvtMthDates(date, 16, undefined),
      });
      _udtThis();

    }
  };

  React.useEffect(() => {
    //hf.l(`icvI1z___TzAby 738: here`);
    _chgDate(pz.cz.date, pz.cz.ltyTgtDatez);
  }, [
    pz.cz.date
  ])

  React.useEffect(() => {
    //hf.l(`icvI1z___TzAby 744: ${hf.s(pz.cz.dates)}`);
    if (pz.cz.dates) {
      hf.udtDz($tgtz1, {
        crt: pz.cz.dates[0],
        dates: pz.cz.dates,
      });
      _udtThis();
    }
  }, [
    pz.cz.dates
  ])

  if (pz.cz.bEdit) { // 日付の $csl の表示に必要
    $setCellCsN2({
      ccd: `${pz.sPz.crt.dffz.clr}5`,
      _611s: $_611s,
      dates: $tgtz1.dates,
      cellCsN2: $cellCs12,
      onPrs: pz.cz.onPrs,
    });
    if (pz.cz.row == 2) {
      $setCellCsN2({
        ccd: `${pz.sPz.crt.dffz.clr}5`,
        _611s: $_611s,
        dates: $tgtz2.dates,
        cellCsN2: $cellCs22,
        onPrs: pz.cz.onPrs,
      });
    }
  }

  if (pz.cz.ltyTgtDatez) { // for lotty
    $setCellCsN4({
      ccd: `${pz.sPz.crt.dffz.clr}4`,
      _601s: $_601s,
      _611s: $_611s,
      dates: $tgtz1.dates,
      cellCsN4: $cellCs14,
      onPrs: pz.cz.onPrs,
      ltyTgtDatez: pz.cz.ltyTgtDatez,
    });
  }
  else {
    hf.clrLs($cellCs14);
  }

  const _hdrs1 = [] as ht.ls;
  $setHdr({
    hdrs: _hdrs1,
    cellCsN1: $cellCs11,
    cellCsN2: $cellCs12,
    cellCsN3: $cellCs13,
    cellCsN4: $cellCs14 // for lotty 
  });

  const _hdrs2 = [] as ht.ls;
  if (pz.cz.row == 2) {
    $setHdr({
      hdrs: _hdrs2,
      cellCsN1: $cellCs21,
      cellCsN2: $cellCs22,
      cellCsN3: $cellCs23
    });
  }

  const _bdys1 = [] as ht.ls;
  $setBdys({
    hdrs: _hdrs1,
    bdys: _bdys1,
    sPz: pz.sPz,
    tgtz: $tgtz1,
    i1zz: pz.cz.i1zz,
    sMsgz: _sMsgz,
    bEdit: pz.cz.bEdit,
    udtThis: _udtThis,
    bMplDay: pz.cz.bMplDay,
    onPrs: pz.cz.onPrs,
  })

  const _bdys2 = [] as ht.ls;
  $setBdys({
    hdrs: _hdrs2,
    bdys: _bdys2,
    sPz: pz.sPz,
    tgtz: $tgtz2,
    i1zz: pz.cz.i1zz,
    sMsgz: _sMsgz,
    bEdit: pz.cz.bEdit,
    udtThis: _udtThis,
    bMplDay: pz.cz.bMplDay,
    onPrs: pz.cz.onPrs,
  })

  const _gStgz = gs.useStgz();
  const _gUserz = gs.useUserz();

  let _bShow = true;
  if (
    pz.cz.role == 'd' && // 公開版
    pz.sPz.crt.ctt == 'r' &&
    $tgtz1.crt >= _gStgz.crt.alyMthSttDate &&
    hfDTM.getNow() < _gStgz.crt.alyOpenDtm
  ) _bShow = false; // エントリー受付日より前で、エントリー対象期間の予約を表示している場合
  //hf.l(`icvI1z___Tz 842: ${_bShow} ${hfDTM.getNow()}, ${$tgtz1.crt}, ${_gStgz.crt.alyMthSttDate}, ${_gStgz.crt.alyOpenDtm}`)  
  /*
    if (
      pz.cz.role == 'd' && 
      pz.sPz.crt.ctt == 'e' && 
      $tgtz1.crt >= _gStgz.crt.alyMthSttDate &&
      (hfDTM.getTdy() < _gStgz.crt.alySttDate || hfDTM.getTdy() > _gStgz.crt.alyEndDate)
    ) _bShow = false; //エントリー受付期間以外で、エントリー対象期間のエントリーを表示している場合
  */
  if (
    pz.cz.role == 'd' &&
    pz.sPz.crt.ctt == 'e' &&
    (hfDTM.getTdy() < _gStgz.crt.alySttDate || hfDTM.getTdy() > _gStgz.crt.alyEndDate)
  ) _bShow = false; //エントリー受付期間以外の場合
  //hf.l(`icvI1z___Tz 861: ${_bShow} ${hfDTM.getTdy()}, ${$tgtz1.crt}, ${_gStgz.crt.alyMthSttDate}, ${_gStgz.crt.alySttDate}, ${_gStgz.crt.alyEndDate}`)  
  //hf.l(`icvI1z___Tz 695: ${hf.s(_gStgz.crt)}`)  
  return (
    cr.c(GridC.N, {
      key: 'IccAby.V3.root',
      abtType: 'nolineCmnz',
      boxStlz: {
        ...a('f/1'),
        ...pz.boxStlz,
      }, // 領域内最大表示に必要
      lineCs: [
        {
          boxStlz: a('f/n'),
          cellCs: [
            pz.cz.bNext != false ?
              {
                boxStlz: a('dw/10 f/n fd/ccc'),
                oClds: [
                  //(pz.cz.role != 'd' || pz.sPz.crt.ctt == 'r') && (!pz.cz.sttMth || String($tgtz1.crt).substring(0, 7) > pz.cz.sttMth) && _bShow ?
                  (
                    pz.cz.role != 'd' || 
                    pz.sPz.crt.ctt == 'r' || 
                    (_gUserz.crt.i19rz?.i19ra4100i == 3 && pz.sPz.crt.ctt == 'e') // 泉寿荘
                  ) && (!pz.cz.sttMth || String($tgtz1.crt).substring(0, 7) > pz.cz.sttMth) && _bShow ?
                    cr.c(BtnC.N, {
                      key: -10,
                      abtType: 'leftIconz',
                      bfrIconCz: {
                        iconPtyz: a('icn/chevron-left ics/2'),
                      },
                      lblCz: {
                        textz: {
                          pfx: '前月',
                        },
                      },
                      pslPtyz: {
                        onPress: async () => {
                          const _crt = hfDTM.addMth($tgtz1.crt, -1);
                          _chgDate(_crt, pz.cz.ltyTgtDatez);
                        }
                      }
                    })
                    : undefined,
                ]
              }
              : null,
            {
              boxStlz: a('f/1 fd/csc'),
              oClds: [

                cr.c(TextC.N, {
                  key: -10,
                  textz: {
                    pfx:
                      pz.cz.pfx ?
                        pz.cz.pfx + ' ' + hfDTM.f($tgtz1.crt, '年月', false)
                        : pz.sPz.crt.ctt == 'r' ?
                          '現在の空き状況'
                          : pz.sPz.crt.ctt == 'e' ?
                            '現在のエントリー状況'
                            : '',
                    stlz: a('tb'),
                  },
                }),

                cr.c(BoxC.N, {
                  key: -20,
                  boxStlz: a(`dw/f fd/rac`),
                  oClds: [
                    pz.cz.role != 'd' ? // スタッフの場合
                    cr.c(TextC.N, {
                      key: -20,
                      textz: {
                        pfx:
                          pz.sPz.crt.ctt == 'r' ?
                            '【空白】…予約可　【灰色】…予約済・予約不可'
                            : pz.sPz.crt.ctt == 'e' ?
                              '【灰色】…エントリー不可　数字…現在のエントリー数'
                              : '',
                        stlz: a('ml/1 ts/s'),
                      },
                    })
                    : undefined,
                    pz.cz.bChkAll == true ? // クリックした時間帯のすべてを選択／解除を使用の場合
                    cr.c(CbxC.SS, {
                      key: -10,
                      //boxStlz: a(`dh/f dw/f fd/rsc`),
                      vle: -1,
                      cz: {
                        onChg: (_n: ht.n) => {
                          $chkAll = _n;
                        }
                      },
                      cbxCz: {
                        boxStlz: {
                          sctz: a(`fd/ccc sc/t`),
                          nmlz: a(`fd/ccc sc/t`),
                        },
                        iconPtyz: {
                          sctz: a(`icc/lt9 ics/3`),
                          nmlz: a(`icc/lt9 ics/3`),
                        }
                      },
                      lblCz: {
                        textz: {
                          pfx: 'クリックした時間帯のすべてを選択・解除',
                          stlz: a(`tc/lt9`),
                        }
                      },
                    })
                    : undefined,
                  ]
                })

              ]
            },

/* 20231205 削除 オフライン抽選
            pz.cz.ltyTgtDatez ?
              {
                boxStlz: a('f/n fd/rcc ph/1'),
                oClds: [

                  cr.c(CbxC.SS, {
                    key: $tgtz1.crt,
                    boxStlz: a(`dh/f dw/f fd/rsc`),
                    vle: $chkAll,
                    cz: {
                      onChg: (_n: ht.n) => {
                        $chkAll = _n;
                        hfDTM.grtDates(hfDTM.cvtFdm($tgtz1.crt), hfDTM.cvtLdm($tgtz1.crt)).map((date: ht.s) => {
                          if (pz.cz.ltyTgtDatez) {
                            pz.cz.ltyTgtDatez[date] = _n;
                            $chkAll = -1;
                          }
                        });
                        _udtThis();
                      }
                    },
                    cbxCz: {
                      boxStlz: {
                        sctz: a(`fd/ccc sc/t`),
                        nmlz: a(`fd/ccc sc/t`),
                      },
                      iconPtyz: {
                        sctz: a(`icc/lt9 ics/3`),
                        nmlz: a(`icc/lt9 ics/3`),
                      }
                    },
                    lblCz: {
                      textz: {
                        pfx: 'すべて選択',
                        stlz: a(`tc/lt9`),
                      }
                    },
                  })

                ]
              }
              : undefined,
*/

            pz.cz.bNext != false ?
              {
                boxStlz: a('dw/10 f/n fd/ccc'),
                oClds: [
                  (
                    pz.cz.role != 'd' || 
                    pz.sPz.crt.ctt == 'r' ||
                    (_gUserz.crt.i19rz?.i19ra4100i == 3 && pz.sPz.crt.ctt == 'e') // 泉寿荘
                  ) && (!pz.cz.endMth || String($tgtz1.crt).substring(0, 7) < pz.cz.endMth) && _bShow ?
                    cr.c(BtnC.N, {
                      key: -10,
                      abtType: 'rhtIconz',
                      atrIconCz: {
                        iconPtyz: a('icn/chevron-right ics/2'),
                      },
                      lblCz: {
                        textz: {
                          pfx: '次月',
                        },
                      },
                      pslPtyz: {
                        onPress: () => {
                          const _crt = hfDTM.addMth($tgtz1.crt, +1);
                          _chgDate(_crt, pz.cz.ltyTgtDatez);
                        }
                      }
                    })
                    : undefined,
                ]
              }
              : null,
          ]
        },
        pz.cz.role == 'd' ?
          {
            boxStlz: a('f/n'),
            cellCs: [
              {
                boxStlz: a('dw/f fd/rcc'),
                oClds: [
                  cr.c(TextC.N, {
                    key: -20,
                    textz: {
                      pfx:
                        pz.sPz.crt.ctt == 'r' ?
//                          '【空白】…予約可　×…予約済・予約不可'
                          '【空白】…予約可　【灰色】…予約済・予約不可'
                        : pz.sPz.crt.ctt == 'e' ?
                          '【灰色】…エントリー不可　数字…現在のエントリー数'
                        : '',
                      stlz: a('ts/s'),
                    },
                  }),
                ]
              }
            ]
          }
          : undefined,
        _bShow ?
          {
            cellCs: [
              {
                boxStlz: a('f/1'),
                oClds: [
                  cr.c(SrlC.V, {
                    key: -40,
                    srlPtyz: {
                      showsVerticalScrollIndicator: true,
                    },
                    oClds: [
                      cr.c(GridC.N, {
                        key: -30,
                        abtType: 'cmnAbyz',
                        lineCs: _hdrs1,
                      }),
                      cr.c(GridC.N, {
                        key: -40,
                        abtType: 'cmnAbyz',
                        lineCs: _bdys1,
                      })
                    ]
                  }),
                ]
              }
            ]
          }
          : undefined,
        _bShow ?
          (pz.cz.row == 2) ?
            {
              cellCs: [
                {
                  boxStlz: a('f/1'),
                  oClds: [
                    cr.c(SrlC.V, {
                      key: -40,
                      srlPtyz: {
                        showsVerticalScrollIndicator: true,
                      },
                      oClds: [
                        cr.c(GridC.N, {
                          key: -30,
                          abtType: 'cmnAbyz',
                          lineCs: _hdrs2,
                        }),
                        cr.c(GridC.N, {
                          key: -40,
                          abtType: 'cmnAbyz',
                          lineCs: _bdys2,
                        })
                      ]
                    }),
                  ]
                }
              ]
            }
            : undefined
          : undefined,
        !_bShow ?
          {
            cellCs: [
              {
                boxStlz: a('f/1 mt/4'),
                oClds: [
                  cr.c(TextC.N, {
                    key: -40,
                    textz: {
                      pfx:
                        pz.sPz.crt.ctt == 'r' ?
                          _gStgz.crt.rsvOpenMsg
                          : pz.sPz.crt.ctt == 'e' ?
                            _gStgz.crt.alyOpenMsg
                            : '',
                    }
                  }),
                ]
              }
            ]
          }
          : undefined,
      ]
    })
  )
};
